





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { MapGameRole } from '@/core/constants';
import { AdminApi } from '@/services/api/api.admin';
import { SelectPair } from '@/core/types';
import { ApiPermissions } from '@/core/security/Permissions';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { User } from '@/models/user/user.model';
import { UserDetailsViewModel, UpdateAccountAccessRequest, GameRole } from '@/types/apiServerContract';

@Component
export default class EditUserGameRanks extends Vue {
	@Prop({ required: true })
	user!: User;

	@Prop({ required: true })
	userData!: UserDetailsViewModel;

	permissions: string[] = [ApiPermissions.User.EditIngameAccountRank];
	roles: GameRole[] = [GameRole.Player, GameRole.Trial, GameRole.GameMaster, GameRole.Admin];

	role: GameRole = GameRole.Admin;
	loading: boolean = false;

	Reset() {
	    this.role = this.userData.account.accountAccess.find(x => x.realmId === RealmsModule.activeRealmId)?.gmLevel ?? 0;
	}

	async UpdateRoles() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to save these changes?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    this.loading = true;

	    try {
	        const request: UpdateAccountAccessRequest = {
	            accountId: this.userData.account.id,
	            accessId: this.role,
	            realmId: RealmsModule.activeRealmId
	        };
	        await AdminApi.UpdateAccountAccess(request);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast(`${this.user.userName}'s ingame rank have been updated for ${RealmsModule.ActiveRealm!.name}`, {
	        variant: 'success',
	        title: 'Success'
	    });
	}

	get SecurityRoles() {
	    const roles: SelectPair[] = [];

	    for (const n in GameRole) {
	        const val = GameRole[n] as any;
	        if (isNaN(val)) continue;

	        roles.push({
	            value: val,
	            text: MapGameRole(val)
	        });
	    }

	    return roles.reverse();
	}

	mounted() {
	    this.Reset();
	}
}
